<template>
  <div class="plan">
    <!-- 面包屑 -->
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>职业规划</el-breadcrumb-item>
      </el-breadcrumb>
      <h1>职业规划</h1>
    </div>
    <div class="plan-main ">
      <div class="tit clearfix">
        <h1 class="fl">个人3-5年职业发展规划</h1>
        <!-- <el-button
          class="fr theme"
          icon="el-icon-edit"
        >编辑</el-button> -->    
      </div>
      <div class="text-textarea">
        <!-- @input="autoTextarea" -->
        <textarea
          class="myCircle_input"
          maxlength="1000"
          placeholder="请输入不超过1000字。"
          v-model="form.teacherArchivesDTO.professional"
          ref="elememt"
        >
        </textarea>
      </div>
      <el-button
        class="theme"
        @click="onSubmit"
        :loading="infoLoad"
      >保存</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.init();
  },
  data() {
    return {
      infoLoad: false,
      form: {
        teacherArchivesDTO: {
          professional: "",
        },
      },

      isHeight: true,
      minHeight: 250,
    };
  },
  methods: {
    init() {
      this.$store.dispatch("getUserInfo");
      this.form.teacherArchivesDTO.professional = this.userInfo.teacherArchivesDTO.professional;
    },
    onSubmit() {
      //更新
      this.form.userId = this.userInfo.userId;
      this.form.id = this.userInfo.id;
      this.form.schoolCodes = [this.userInfo.schoolCode];
      this.infoLoad = true;
      this.$axios
        .post("/user/updateTeacherInfo", this.form)
        .then((res) => {
          if (res.resultCode === 200) {
            this.$message({
              message: "更新成功",
              type: "success",
              duration: 2000,
              offset: 150,
            });
            this.infoLoad = false;
          } else {
            this.$message({
              error: res.msg,
              type: "success",
              duration: 2000,
              offset: 150,
            });
          }
        })
        .catch((err) => {
          console.log("update error", err);
        });
    },

    //高度自适应
    // autoTextarea() {
    //   var extra = 0, //设置光标与输入框保持的距离(默认0)
    //      maxHeight = 0; //设置最大高度(可选)
    //   var _that = this;
    //   var isFirefox = !!document.getBoxObjectFor || "mozInnerScreenX" in window,
    //     isOpera = !!window.opera && !!window.opera.toString().indexOf("Opera");
    //   var paddingTop, paddingBottom;
    //   var style, _length, valueLength, stylHeight, scrollHeight, currHeight;

    //   this.$nextTick(function () {
    //     if (this.isHeight) {
    //       this.isHeight = false;
    //       this.minHeight = parseFloat(
    //         window.getComputedStyle(this.$refs.elememt).height
    //       );
    //     }

    //     paddingTop = parseInt(
    //       window.getComputedStyle(this.$refs.elememt).paddingTop
    //     );
    //     paddingBottom = parseInt(
    //       window.getComputedStyle(this.$refs.elememt).paddingBottom
    //     );
    //     style = this.$refs.elememt.style;
    //     _length = this.$refs.elememt._length;
    //     valueLength = this.$refs.elememt.value.length;
    //     stylHeight = this.$refs.elememt.style.height;
    //     scrollHeight = this.$refs.elememt.scrollHeight;
    //     currHeight = this.$refs.elememt.currHeight;

    //     change();
    //   });

    //   function change() {
    //     var height,
    //       padding = 0;

    //     if (_length === valueLength) return;
    //     _length = valueLength;

    //     if (!isFirefox && !isOpera) {
    //       padding = paddingTop + paddingBottom;
    //     }
    //     stylHeight = _that.minHeight + "px"; //30px
    //     if (scrollHeight > _that.minHeight) {
    //       if (maxHeight && scrollHeight > maxHeight) {
    //         height = maxHeight - padding;
    //         style.overflowY = 'auto';
    //         //style.overflowY = "hidden";
    //       } else {
    //         height = scrollHeight - padding; //undefined 30 9
    //         style.overflowY = "hidden";
    //       }

    //       style.height = height + extra + "px";
    //       currHeight = parseInt(style.height);
    //     }
    //   }
    // },
  },
};
</script>

<style lang="less" scoped>
.plan {
  margin: 20px;
  overflow: hidden;
  .crumbs {
    height: 70px;
    .el-breadcrumb {
      font-size: 15px;
    }
    h1 {
      font-size: 20px;
      margin-top: 15px;
      border-width: 500;
    }
  }
  .plan-main {    
    width: 100%;
    border-radius: 20px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 25px 50px;
    .tit {
      h1 {
        font-size: 20px;
        margin-top: 15px;
        border-width: 500;
      }
    }
    .text-textarea {
      margin-top: 15px;
      margin-bottom: 15px;
      .myCircle_input {
        border-radius: 15px;
        padding: 15px;
        width: 100%;
        height: 300px;
        font-size: 17px;
        line-height: 20px;
        color: #000;
        opacity: 0.55;
        border: 1px solid @hui-color;

        outline: none;
      //  overflow: hidden;
        resize: none; //调整属性指定一个元素是否是由用户调整大小的  both/horizontal 宽度/vertical 高度
        word-break: break-all;
        box-sizing: border-box;
      }
    }
    .el-button {
      margin-top: 5px;
    }
  }
}
</style>


